import api from './client'

export interface LoginRequest {
  username: string
  password: string
}

export interface LoginResponse {
  access_token: string
  token_type: string
  expires_at: string
}

export interface UserInfo {
  username: string
  role: string
  created_at: string
}

export async function login(credentials: LoginRequest): Promise<LoginResponse> {
  const response = await api.post<LoginResponse>('/auth/login', credentials)
  return response.data
}

export async function logout(): Promise<void> {
  await api.post('/auth/logout')
}

export async function getCurrentUser(): Promise<UserInfo> {
  const response = await api.get<UserInfo>('/auth/me')
  return response.data
}

export async function refreshToken(): Promise<LoginResponse> {
  const response = await api.post<LoginResponse>('/auth/refresh')
  return response.data
}
